<script>
	import { navigate } from "svelte-routing";
	import { Button, Label } from "sveltestrap";
	import CustomInput from "../components/CustomInput/CustomInput.svelte";
	import ErrorMessageHandler from "../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import SuccessMessageHandler from "../components/ErrorMessageHandler/SuccessMessageHandler.svelte";
	import Loader from "../components/Loader/Loader.svelte";
	import { doForgot } from "../store/auth/auth";
	import { errorMessage, loading, successMessage } from "../store/store";
	let img = "/assets/getgo-logo-green.png";
	let email = "";
	let err;
	let success;

	errorMessage.subscribe((value) => {
		err = value;
		// console.log(err);
	});

	successMessage.subscribe((value) => {
		success = value;
		// console.log(success);
	});

	async function submit() {
		if (email === "") {
			errorMessage.set("Email is required");
			return;
		} else {
			doForgot({ email });
		}
	}
	let load;
	loading.subscribe((value) => {
		load = value;
	});

	const handleNavigate = () => {
		errorMessage.set("");
		successMessage.set("");
		navigate("/login");
	};
</script>

<main>
	<div>
		<div class="main-container">
			<div class="left">
				<div
					class="d-flex flex-column align-items-center justify-content-center w-100"
				>
					<div>
						<img
							src="/assets/getgo-logo-descriptor.png"
							alt="getgologo"
							style="width: 200px; height: 113px"
						/>
					</div>
					<div class="copyright">
						<span> Copyright © 2025. All Rights Reserved </span>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="sign-in">
					<h4>Please input your email to reset your password!</h4>
					<ErrorMessageHandler message={err} />
					<SuccessMessageHandler message={success} />
					<div class="mt-3 mb-1">
						<Label for="email">
							<b>Email</b>
						</Label>
					</div>
					<div>
						<CustomInput
							id="email"
							type="email"
							bind:value={email}
						/>
					</div>
					<div class="forgot my-4">
						<p>Do you want to login?&nbsp;&nbsp;</p>
						<p
							class="link font-weight-bold"
							on:click={handleNavigate}
							on:keydown={() => {}}
						>
							Click here
						</p>
					</div>
					<div class="my-2">
						<Button
							block
							class="themeButton primary"
							on:click={submit}
						>
							{#if load}
								<Loader />
							{:else}
								Reset Password
							{/if}
						</Button>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>
